import React, { useState } from "react";
import "./Login.scss";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { userAuthServices } from "../../../Services/API/userAuthServices";
import { sessionServices } from "../../../Utils/SessionServices";
import { SyncOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

export default function LoginPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [forgotForm] = Form.useForm();
  const [activeComponent, setActiveComponent] = useState("Login");
  const [ButtonLoader, setButtonLoader] = useState(false);

  const onFinish = async (values) => {
    setButtonLoader(true);
    const { email, password } = values;
    userAuthServices
      .loginService(email, password)
      .then((res) => {
        const token = res?.data?.idToken;
        sessionServices.setSessionStorageItem("token", token);
        sessionServices.setSessionStorageItem("username", res?.data?.name);
        sessionServices
          ?.setSessionStorageItem("role", res?.data?.userType)
          .then(() => {
            navigate("/");
          })
          .catch((err) => console.log(err));
        setButtonLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setButtonLoader(false);
        form.setFields([
          {
            name: "email",
            errors: [""],
          },
          {
            name: "password",
            errors: [err?.response?.data],
          },
        ]);
      });
  };

  const resetPassword = async (values) => {
    setButtonLoader(true);
    const { email } = values;
    try {
      const resp = await userAuthServices.forgotPasswordService(email);
      toast.success(
        resp?.data?.message ||
          "Password reset information has been sent to your registered email"
      );
      setActiveComponent("Login");
    } catch (error) {
      console.log("error", error);
      toast.error("Sorry something went wrong");
    } finally {
      setButtonLoader(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="container">
      <div className="leftContainer">
        <div className="text-container">
          <div className="title">
            LET'S FUNDRAISE
            <br /> TOGETHER!
          </div>
          <div className="subtitle">
            <span>So Every Team Can Succeed</span>
          </div>
        </div>
        {activeComponent === "Login" ? (
          <div className="loginBox">
            <div className="login-heading">
              <h1 className="formHeading">LOGIN</h1>
            </div>
            <div className="formWrapper">
              <Form
                name="form"
                form={form}
                className="login-form-component"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
              >
                <Form.Item
                  label={<div className="form-label">Email</div>}
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email address!",
                    },
                    {
                      required: true,
                      message: "Please enter your email address",
                    },
                  ]}
                  className="login-form-item"
                  required={false}
                >
                  <Input className="input" autoComplete="off" />
                </Form.Item>

                <Form.Item
                  label={<div className="form-label">Password</div>}
                  name="password"
                  className="login-form-item"
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password",
                    },
                  ]}
                >
                  <Input.Password
                    className="input"
                    autoComplete="new-password"
                  />
                </Form.Item>
              </Form>
            </div>
            <div className="login-btn-container">
              <Button
                className="submit-button"
                onClick={() => form.submit()}
                loading={ButtonLoader && <SyncOutlined spin />}
              >
                LOGIN
              </Button>
            </div>

            <div className="loginFooterWrapper">
              <div
                className="forgotPassword"
                onClick={() => {
                  setActiveComponent("forgotPassword");
                  setButtonLoader(false);
                }}
              >
                <span>Forgot Password?</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="loginBox">
            <div className="login-heading">
              <h1 className="formHeading">FORGOT PASSWORD</h1>
            </div>
            <div className="formWrapper">
              <Form
                form={forgotForm}
                name="resetForm"
                initialValues={{
                  remember: true,
                }}
                className="login-form-component"
                onFinish={resetPassword}
                onFinishFailed={onFinishFailed}
                layout="vertical"
              >
                <Form.Item
                  label={<div className="form-label">Email</div>}
                  name="email"
                  required={false}
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email address!",
                    },
                    {
                      required: true,
                      message: "Please enter your email address",
                    },
                  ]}
                  className="login-form-item"
                >
                  <Input className="input" />
                </Form.Item>
              </Form>
            </div>
            <div className="login-btn-container">
              <Button
                className="submit-button"
                onClick={() => form.submit()}
                loading={ButtonLoader && <SyncOutlined spin />}
              >
                RESET PASSWORD
              </Button>
            </div>
            <div className="loginFooterWrapper">
              <div
                className="forgotPassword"
                onClick={() => {
                  setActiveComponent("Login");
                }}
              >
                <span>Go back</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="rightContainer"></div>
    </div>
  );
}
